<template>
	<div class="icon-restart">
		<svg
			width="20.000000"
			height="20.000000"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs />
			<path
				id="path (Граница)"
				d="M0.24 7.76C0.08 8.49 0 9.23 0 10C0 10.39 0.3 10.69 0.69 10.69C1.08 10.69 1.39 10.39 1.39 10C1.39 9.32 1.46 8.67 1.61 8.03C1.72 7.56 1.87 7.1 2.06 6.65C2.27 6.15 2.52 5.68 2.81 5.24C3.13 4.76 3.49 4.32 3.9 3.91C4.31 3.49 4.76 3.13 5.24 2.81C5.68 2.52 6.14 2.27 6.63 2.07C7.07 1.88 7.51 1.74 7.97 1.63C8.62 1.47 9.3 1.39 10 1.39C10.8 1.39 11.59 1.48 12.35 1.67C12.84 1.79 13.32 1.95 13.8 2.14C14.76 2.55 15.67 3.1 16.52 3.81C17.02 4.23 17.48 4.68 17.9 5.17L15.17 5.17C14.78 5.17 14.47 5.47 14.47 5.86C14.47 6.26 14.78 6.56 15.17 6.56L19.3 6.56C19.49 6.56 19.65 6.49 19.79 6.36C19.93 6.22 20 6.06 20 5.86L20 1.21C20 0.82 19.69 0.52 19.3 0.52C18.91 0.52 18.6 0.82 18.6 1.21L18.6 3.86C18.23 3.46 17.84 3.09 17.42 2.74C16.46 1.94 15.43 1.31 14.33 0.86C13.77 0.62 13.21 0.44 12.62 0.3C11.77 0.1 10.9 0 10 0C9.21 0 8.44 0.08 7.69 0.26C7.14 0.39 6.61 0.56 6.09 0.78C5.51 1.02 4.97 1.31 4.46 1.65C3.91 2.02 3.39 2.44 2.91 2.93C2.44 3.4 2.02 3.91 1.65 4.46C1.31 4.98 1.02 5.52 0.78 6.1C0.55 6.64 0.37 7.2 0.24 7.76ZM20 10C20 9.6 19.69 9.3 19.3 9.3C18.91 9.3 18.6 9.6 18.6 10C18.6 10.64 18.53 11.27 18.39 11.89C18.28 12.38 18.12 12.87 17.92 13.34C17.72 13.82 17.48 14.27 17.2 14.7C16.88 15.19 16.5 15.65 16.08 16.08C15.65 16.5 15.19 16.88 14.7 17.2C14.27 17.48 13.82 17.72 13.34 17.92C12.87 18.12 12.38 18.28 11.89 18.39C11.27 18.53 10.64 18.6 10 18.6C9.82 18.6 9.64 18.59 9.47 18.58C8.58 18.51 7.7 18.27 6.84 17.86C6 17.46 5.19 16.9 4.4 16.2C3.94 15.77 3.5 15.32 3.1 14.82L5.93 14.82C6.32 14.82 6.63 14.52 6.63 14.13C6.63 13.73 6.32 13.43 5.93 13.43L1.73 13.43C1.53 13.43 1.37 13.5 1.23 13.63C1.1 13.77 1.03 13.93 1.03 14.13L1.03 18.78C1.03 19.17 1.33 19.47 1.73 19.47C2.12 19.47 2.42 19.17 2.42 18.78L2.42 16.18C2.75 16.55 3.1 16.9 3.47 17.23C4.35 18.03 5.27 18.66 6.24 19.12C7.2 19.58 8.17 19.86 9.17 19.95C9.44 19.98 9.72 20 10 20C10.74 20 11.46 19.92 12.16 19.76C12.75 19.63 13.32 19.45 13.89 19.21C14.45 18.97 14.98 18.69 15.48 18.36C16.05 17.99 16.58 17.55 17.07 17.07C17.55 16.58 17.99 16.05 18.36 15.48C18.69 14.98 18.97 14.45 19.21 13.89C19.45 13.32 19.63 12.75 19.76 12.16C19.92 11.46 20 10.74 20 10Z"
				:fill="color"
				fill-opacity="1.000000"
				fill-rule="evenodd"
			/>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
	props: {
		color: { type: String, default: "#77797C" },
	},
})
export default class IconRestart extends Vue {}
</script>

<style scoped lang="scss">
.icon-restart {
	display: flex;
}
</style>
